import React from "react";
import { Modal } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "./OfferReadyModal.css";

const copyByProduct = {
  personal: {
    body: "A MAS-licensed moneylender has reviewed your request and sent you an in-principle offer.",
    badge: "Same offer honoured at the branch - guaranteed",
  },
  corporate: {
    body: "A partner lender has reviewed your request and sent you an in-principle offer.",
    badge: "Your offer is ready to review - no obligation",
  },
};

const OfferReadyModal = ({ open, product = "personal", onClose, onViewOffer }) => {
  const copy = copyByProduct[product] || copyByProduct.personal;

  return (
    <Modal
      open={open}
      footer={null}
      centered
      closable={false}
      width={520}
      className="sl-offer-ready-modal"
      onCancel={onClose}
      maskClosable
      destroyOnClose
    >
      <button
        type="button"
        className="sl-offer-ready-close"
        aria-label="Close offer notification"
        onClick={onClose}
      >
        <CloseOutlined />
      </button>

      <div className="sl-offer-ready-icon" aria-hidden="true">
        <span>🎉</span>
      </div>

      <h2>Congratulations - you have an offer!</h2>
      <p className="sl-offer-ready-body">{copy.body}</p>

      <div className="sl-offer-ready-badge">
        <CheckOutlined />
        <span>{copy.badge}</span>
      </div>

      <button
        type="button"
        className="sl-offer-ready-primary"
        onClick={onViewOffer}
      >
        View my offer
      </button>

      <button
        type="button"
        className="sl-offer-ready-later"
        onClick={onClose}
      >
        I'll review it later
      </button>

      <p className="sl-offer-ready-note">
        No obligation to accept. Reviewing your offer will not affect your
        credit score.
      </p>
    </Modal>
  );
};

export default OfferReadyModal;
